import { Controller } from "@hotwired/stimulus"
import { animate } from "motion"

// Auto-dismissing toast flash. Each [data-flash-target="toast"] fades out
// after a delay; tapping one closes it early. Progressive enhancement:
// without JS the toasts simply stay until the next navigation.
export default class extends Controller {
  static targets = ["toast"]

  connect() {
    this.timers = this.toastTargets.map((toast, i) => {
      toast.addEventListener("click", () => this.remove(toast), { once: true })
      return setTimeout(() => this.remove(toast), 4000 + i * 400)
    })
  }

  disconnect() {
    this.timers?.forEach(clearTimeout)
  }

  remove(toast) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      toast.remove()
      return
    }
    animate(toast, { opacity: 0, transform: "translateY(-8px)" }, { duration: 0.25 })
      .finished.then(() => toast.remove())
  }
}
